export default {"src":"/_next/static/media/SYY.b5d08000.svg","height":18,"width":18};